import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '../../shared/services/http.service';
import { GatewayId } from '../../site-gateway/models/gateway';
import { Toolbox } from '../models/Toolbox';

import { ToolboxGateway } from './ToolboxGateway';

@Injectable()
export class HttpToolboxGateway implements ToolboxGateway {
    constructor(private httpService: HttpService) {}

    getToolboxes(): Observable<GatewayId[]> {
        return this.httpService
            .get(`/v1/toolbox`)
            .pipe(map((toolboxes: Toolbox[]) => toolboxes?.map(({ gatewayId }) => gatewayId)));
    }
}
